import { CtaCard } from '@app/components/blocks/card/CtaCard'
import { initiativeCreationSteps } from '../../shared/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import { useClient } from '@based/sdk'
import { useEffect } from 'react'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'

export const FinishStep = ({ initiativeId }: { initiativeId: number }) => {
  const client = useClient()
  const t = useTranslations().app.dashboard.initiative.creation

  useEffect(() => {
    void client.call('calculate-slug-initiative', { id: initiativeId })
  }, [client, initiativeId])

  return (
    <CreationGuide
      selectedPhaseType={null}
      currentStep={initiativeCreationSteps.finish}
    >
      <Column gap="2.5rem" alignItems="stetch">
        <Row>
          <CtaCard
            title={t.eLearningCardTitle}
            subtitle={t.eLearningCardDescription}
            //illustration={searchForGroup}
            linkText={t.eLearningCardLinkLabel}
            linkHref={pages.elearning}
            border={true}
            style={{
              padding: '1.5rem 1rem',
            }}
          />
          <CtaCard
            title={t.knowledgeHubCardTitle}
            subtitle={t.knowledgeHubCardDescription}
            //illustration={searchForGroup}
            linkText={t.knowledgeHubCardLinkLabel}
            linkHref={pages.knowledgeHub}
            border={true}
            style={{
              padding: '1.5rem 1rem',
            }}
          />
        </Row>
      </Column>
    </CreationGuide>
  )
}
